export default "__VITE_ASSET__6798d470__"